<template>
  <div>
    <KTCard ref="preview" v-bind:title="'Add'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'stock-audit-add' }">{{
            $t("NEW_AUDIT")
          }}</router-link>
        </h3>
      </template>
      <template v-slot:body>
        <b-form>
          <StockAuditAddStepper
            v-show="!firstLoader"
            :firstLoader.sync="firstLoader"
          >
          </StockAuditAddStepper>
          <SkeletonLoaderMain :visible="firstLoader"></SkeletonLoaderMain>
          <v-overlay
            :value="
              !firstLoader &&
              (isLoadingStock == true || isLoadingSharedStore == true)
            "
          >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div
          v-show="_.size(errors) > 0"
          role="alert"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import StockAuditAddStepper from "@/modules/stock/components/StockAuditAddStepper.vue";

import KTCard from "@/view/content/Card.vue";
import { mapGetters, mapState } from "vuex";

export default {
  mixins: [],
  data() {
    return {
      errors: {},
      firstLoader: true
    };
  },
  components: {
    KTCard,
    StockAuditAddStepper
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock audit add", route: { name: "stock-audit-add" } }
    ]);
  },
  computed: {
    ...mapGetters(["isLoadingStock", "isLoadingSharedStore", "currentUser"]),
    ...mapState({
      errors: (state) => state.auth.errors
    })
  },
  methods: {}
};
</script>
